import { render } from "./PrivacyPolicy.vue?vue&type=template&id=06f13f86"
const script = {}

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__